import { AppContent } from '../AppContent';

const alreadyRegistered: AppContent['alreadyRegistered'] = {
  alreadyRegisteredContent: [
    {
      serviceName: 'Online for Business',
      header: 'You’ve already registered',
      notificationHeader: 'Log on using the details you’ve already set up',
      forgottenDetails: 'Forgotten your logon details?',
      youCan: 'You can',
      resetThemOnline: 'reset them online.',
      resetThemOnlineHref:
        'https://onlinebusiness.lloydsbank.co.uk/ib-access/cwa/forgotten-details/index.html#/your-details?_k=e5sfhr',
      btnLabel: 'Log on',
      btnHref:
        'https://onlinebusiness.lloydsbank.co.uk/business/logon/login.jsp?LBGAc=T1BUT1VUTVVMVElNRVNTQUdF.MQ==.TEJHYzM=.eXM3dGJtYzAyMDBYNExGbGxveWRzYmFua2NvbQ==.QU1DVlNfMjMwRDY0M0U1QTI1NTA5ODBBNDk1REI2JTQwQWRvYmVPcmc=.MQ==.QU1DVl8yMzBENjQzRTVBMjU1MDk4MEE0OTVEQjYlNDBBZG9iZU9yZw==.LTIxMjExNzkwMzN8TUNJRFRTfDE5ODE5fE1DTUlEfDMzNjY5MzQ0OTYxODM0MDIxMzEwODYzNjc0MDI3MzcyMjE0Nzk2fE1DQUFNTEgtMTcxMjkxNDU1Nnw2fE1DQUFNQi0xNzEyOTE0NTU2fDZHMXluWWNMUHVpUXhZWnJzel9wa3FmTEc5eU1YQnBiMnpYNWR2SmRZUUp6UFhJbWRqMHl8TUNPUFRPVVQtMTcxMjMxNjk1NnN8Tk9ORXxNQ0FJRHxOT05FfHZWZXJzaW9ufDUuMy4w.T1BUT1VUTVVMVEk=.MDowfGMxOjF8YzM6MHxjNTowfGM0OjB8YzI6MA==.dHM=.bHVtaDMwMmU=#ts:1472813081682,cp.WT_FPC:id%3D0894a421-147f-4162-ac0a-bcd0781f62c2%3Alv%3D1472809477992%3Ass%3D1472809477992,?WT.ac=lloyds-bb-logon-header-primary-logon-business',
    },
  ],
};

export default alreadyRegistered;
